import {Helmet} from "react-helmet";
import PageTitle from "./include/PageTitle";
import React, {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import { server_ip } from "../Utils/Data";

const resolveImageUrl = (src) => {
    if (!src) return "assets/img/project/project-details-img1.jpg";
    if (src.startsWith("http://") || src.startsWith("https://") || src.startsWith("data:")) {
        return src;
    }
    const normalized = src.startsWith("/") ? src : `/${src}`;
    return `${server_ip}${normalized}`;
};

const ProjectDetail = ({title}) => {
    const location = useLocation();

    const defaultObject = {
        client: "Unknown Client",
        title: "Untitled Project",
        description: "No description available.",
        image: "default-image.jpg",
        category: "Uncategorized",
        link: "#",
        date_start: "Not specified",
        date_end: "Not specified",
        created_at: "Not specified",
    };

    const [object, setObject] = useState(location.state?.object || defaultObject);
    console.log(object.category)

    useEffect(() => {
        if (location.state?.object) {
            setObject(location.state.object);
        }
    }, [location.state?.object]);
    return (
        <>
            <Helmet>
                <title>Zaala | Project</title>
            </Helmet>
            <PageTitle title={title}/>

            <section className="project-details">
                <div className="container">
                    <div className="project-details__inner">
                        <div className="project-details__text1">
                            <div className="row">
                                <div className="project-details__text3">
                                    <div className="row">
                                        <div className="col-xl-4 col-lg-4">
                                            <div className="project-details__text3-single">
                                                <h4>
                                                    <span className="icon-link"/> Project Link
                                                </h4>
                                                <p>
                                                    <Link to={`${object.link}`}> {object.link}</Link>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4">
                                            <div className="project-details__text3-single">
                                                <h4>
                                                    <span className="icon-checklist-2"/> Start Date
                                                </h4>
                                                <p>
                                                    <h4>{new Date(object.date_start).toISOString().split("T")[0]}</h4>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4">
                                            <div className="project-details__text3-single">
                                                <h4>
                                                    <span className="icon-checklist-2"/> End Date
                                                </h4>
                                                <p>
                                                    <h4>{new Date(object.date_end).toISOString().split("T")[0]}</h4>

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xl-9 col-lg-12">
                                    <div className="project-details__text1-img">
                                        <div className="row">
                                            <div className="col-xl-5 col-lg-5">
                                                <div className="project-details__text1-img-left">
                                                    <div className="single-img mb-3" style={{
                                                        height: '300px',
                                                        width: '100%',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#f7f7f7',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}>
                                                        <img
                                                            src={resolveImageUrl(object.image1)}
                                                            alt={object.title || "Project"}
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '8px'
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="single-img" style={{
                                                        height: '300px',
                                                        width: '100%',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#f7f7f7',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}>
                                                        <img
                                                            src={resolveImageUrl(object.image2)}
                                                            alt={object.title || "Project"}
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '8px'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-7 col-lg-7">
                                                <div className="project-details__text1-img-right">
                                                    <div className="img-box" style={{
                                                        height: '620px',
                                                        width: '100%',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#f7f7f7',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}>
                                                        <img
                                                            src={resolveImageUrl(object.image3)}
                                                            alt={object.title || "Project"}
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: '100%',
                                                                objectFit: 'contain',
                                                                borderRadius: '8px'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-xl-3">
                                    <div className="project-details__text1-list">
                                        <ul>
                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-user"/>
                                                </div>
                                                <div className="text-box">
                                                    <p>Client</p>
                                                    <h4>{object.client}</h4>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-quote11"/>
                                                </div>
                                                <div className="text-box">
                                                    <p>Title</p>
                                                    <h4>{object.title}</h4>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-open-file"/>
                                                </div>
                                                <div className="text-box">
                                                    <p>Category</p>
                                                    <h4>
                                                        {object.category.name}
                                                    </h4>
                                                </div>

                                            </li>
                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-calendar"/>
                                                </div>
                                                <div className="text-box">
                                                    <p>Project Duration</p>
                                                    <h4>{object.project_duration} Days</h4>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="project-details__text2">
                            <p>{object.description}</p>

                        </div>

                    </div>
                </div>
            </section>

        </>
    )
}

export default ProjectDetail
